import { SIGNIN, SIGNIN_ERR, SIGNUP, SIGNUP_ERR } from '../constants'

const initial = {
  user: null,
  isLoggded: false,
  isSignup: false,
  message: '',
  statut: null,
}

export const authReducer = (state = initial, action) => {
  const { type, payload } = action
  switch (type) {
    case SIGNIN:
      return {
        ...state,
        isLoggded: true,
        user: payload,
      }
    case SIGNUP_ERR:
    case SIGNIN_ERR:
      return {
        ...state,
        isLoggded: false,
        user: null,
        statut: payload.status,
        message: payload,
      }
    case 'REMOVE_ERR':
      return {
        ...state,
        isLoggded: false,
        user: null,
        message: '',
      }
    case SIGNUP:
      return {
        ...state,
        isSignup: true,
        user: payload,
      }

    default:
      return state
  }
}
